import type { JSX } from 'react'

export const BundleCover7 = (): JSX.Element => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 1920 1080'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='none'
  >
    <g clipPath='url(#clip0_628_258)'>
      <rect width='1920' height='1080' fill='#161616' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 989.59C368.237 948.414 1032.24 706.555 1375.58 0H1551.92C1270.06 640.617 750.916 951.541 336.482 1080H0V989.59Z'
        fill='url(#paint0_linear_628_258)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1437.3 1080H954.683C1124.79 1032.22 1321.35 963.289 1503.66 873.527C1668.88 792.188 1814.49 697.586 1920 591.711V804.744C1815.36 886.881 1695.5 957.418 1574.34 1017.07C1529.23 1039.28 1483.37 1060.25 1437.3 1080Z'
        fill='url(#paint1_linear_628_258)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_628_258'
        x1='775.961'
        y1='0'
        x2='775.961'
        y2='1080'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#14165D' />
        <stop offset='1' stopColor='#500E78' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_628_258'
        x1='1437.34'
        y1='591.711'
        x2='1437.34'
        y2='1080'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0D0F39' />
        <stop offset='1' stopColor='#3D1059' />
      </linearGradient>
      <clipPath id='clip0_628_258'>
        <rect width='1920' height='1080' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
